import React from 'react';

import './BetCodeSearch.scss';
import CodeSearch from './CodeSearch/CodeSearch';
import SportBetCodeSearch from './SportBetCodeSearch/SportBetCodeSearch';

interface BetCodeProps {
    productType: number
}

export default function BetCodeSearch({ productType } : BetCodeProps) {

  return (
    <div className="code-search">
      { productType !== 4 && <SportBetCodeSearch productType={ productType } /> }
      { productType === 4 && <CodeSearch /> }
    </div>
  );
}
